import dayjs from 'dayjs';

const utc = require('dayjs/plugin/utc');
const timezone = require('dayjs/plugin/timezone');

dayjs.extend(utc);
dayjs.extend(timezone);


const DOMINICAN_TZ = 'America/Dominica'; // AST

dayjs.tz.setDefault(DOMINICAN_TZ)

export const toDrDateTime = (datetime) => {
    // This is to make all datetime fields consistent, some come with a Timezone.
    if (typeof datetime === 'string') datetime = datetime.replace('Z', '');
    const inUTC = dayjs(datetime).tz("UCT", true);
    return inUTC.tz(DOMINICAN_TZ);
}

export const toDrDate = (date) => {
    return dayjs(date).tz(DOMINICAN_TZ, true);
}

export const getBusinessDatesCount = (startDate, endDate) => {
    let count = 0;
    let curDate = parseInt(+startDate / 86400000, 10) * 86400000;
    while (curDate < parseInt(+endDate / 86400000, 10) * 86400000) {
        const dayOfWeek = new Date(curDate).getDay();
        const isWeekend = (dayOfWeek === 6) || (dayOfWeek === 0);
        if (!isWeekend) {
            count += 1;
        }
        curDate = curDate + 24 * 60 * 60 * 1000
    }
    return count;
}

/**
 * Calculate selection limits supporting overnight and allowance.
 * - startEndTime: "11:00pm - 1:00am"
 * - shiftDate: base date of the shift (string or Dayjs)
 * - allowanceHours: additional hours after the end (default 3)
 */
export const getDateTimeBounds = ({ startEndTime, shiftDate, allowanceHours = 3 }) => {
  const [rawStart, rawEnd] = (startEndTime || "").split(" - ");
  if (!rawStart || !rawEnd || !shiftDate) return {};

  const base = dayjs(shiftDate);
  const startParsed = dayjs(rawStart, "h:mma");
  const endParsed = dayjs(rawEnd, "h:mma");

  const start = base
    .set("hour", startParsed.hour())
    .set("minute", startParsed.minute())
    .set("second", 0)
    .set("millisecond", 0);

  let end = base
    .set("hour", endParsed.hour())
    .set("minute", endParsed.minute())
    .set("second", 0)
    .set("millisecond", 0);

  const overnight = end.isBefore(start);
  if (overnight) end = end.add(1, "day");
  
  const minDateTime = start;
  const maxDateTime = end.add(allowanceHours, "hour");
  const minDate = base;
  const maxDate = overnight ? base.add(1, "day") : base;


  return { minDate, maxDate, minDateTime, maxDateTime, isOvernight: overnight };
}